export default __webpack_public_path__ + "assets/9af10e5f1fbdced152ce4108d2c19cf3.jpg";